import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'app/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'app/components/ui/table';
import { useDashboardSlice } from '../../slice';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import { ArrowRight, Users } from 'lucide-react';
import { formatISTDateToNow } from 'utils/formatRelativeTime';
import { convertDateFormat } from 'utils/format-date';
export function RecentUsersTable() {
  const { useGetRecentUsersQuery } = useDashboardSlice();
  const [getRecentUsers, { data: recentUsers, error, isLoading }] =
    useGetRecentUsersQuery({});

  useEffect(() => {
    getRecentUsers();
  }, []);

  return (
    <Card className="border-none bg-white  dark:bg-transparent rounded-xl overflow-hidden">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 py-3 border-b border-gray-200 bg-[#0E7490] text-white border-sky-500">
        <CardTitle className="text-md font-medium flex items-center gap-2">
          <Users className="w-4 h-4 text-white" />
          Recent Users
        </CardTitle>
        <Link
          to="/users"
          className="text-xs  hover:underline uppercase flex items-center gap-1"
        >
          View All <ArrowRight className="w-4 h-4" />
        </Link>
      </CardHeader>
      <CardContent className="mt-4 overflow-x-auto max-h-[530px] overflow-y-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-gray-500 text-xs uppercase">
                User Name
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase">
                Phone
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase">
                Created At
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {recentUsers?.data?.length ? (
              recentUsers.data.map(user => (
                <TableRow key={user.user_id} className="hover:bg-gray-50">
                  <TableCell className="font-medium">
                    {user?.username}
                  </TableCell>
                  <TableCell className="text-gray-700">
                    {user?.dial_code ? `+${user.dial_code} ` : ''}
                    {user?.phone}
                  </TableCell>
                  <TableCell className="text-gray-500 text-sm">
                    {convertDateFormat(user.created_at)}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={4}
                  className="text-center text-gray-400 py-8"
                >
                  No recent users found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
